/** API route map: URLS.Controller.Benefits */
export const Benefits = {
      Name: 'Benefits/',
      EditForm: 'edit-form',
      AddForm: 'add-form',
      AddDocument: 'add-document',
      GetForms: 'get-forms',
      GetDocuments: 'get-documents',
      DeleteForm: 'delete-form',
      DeleteDocument: 'delete-document',
      GetPlanDetails: 'get-plan-details',
      AddBenefitProfile: 'add-benefit-profile-details',
      UpdateBenefitProfile: 'update-benefit-profile-details',
      GetBenefitProfile: 'get-benefit-profile-details',
      AddBenefitEligibility: 'add-benefit-eligibility-details',
      UpdateBenefitEligibility: 'update-benefit-eligibility-details',
      GetBenefitEligibility: 'get-benefit-eligibility-details',
      GetEligibleEmployees: 'get-employees-for-types',
      AddPlansDocument: 'add-plans-document',
      GetPlansDocuments: 'get-plans-documents',
      DeletePlansDocument: 'delete-plans-document',
      AddPlansForm: 'add-plans-form',
      GetPlansForms: 'get-plans-forms',
      DeletePlansForm: 'delete-plans-form',
      AddBenefitRate: 'add-benefit-rate-details',
      UpdateBenefitRate: 'update-benefit-rate-details',
      GetBenefitRate: 'get-benefit-rate-details',
      AddClientBenefitProfile: 'add-client-benefit-profile-details',
      UpdateClientBenefitProfile: 'update-client-benefit-profile-details',
      GetClientBenefitProfile: 'get-client-benefit-profile-details',
      GetClientBenefitProfileEnrollment: 'get-client-benefit-profile-details-enrollment',
      GetClientPlanDetails: 'get-client-plan-details',
      GetClientAssociatedPlans: 'get-client-associated-plans',
      AddClientBenefitEligibility: 'add-client-benefit-eligibility-details',
      UpdateClientBenefitEligibility: 'update-client-benefit-eligibility-details',
      GetClientBenefitEligibility: 'get-client-benefit-eligibility-details',
      GetClientBenefitEligibilityRule: 'get-client-benefit-eligibility-rule',
      GetClientBenefitRate: 'get-client-benefit-rate-details',
      AddClientBenefitRate: 'add-client-benefit-rate-details',
      UpdateClientBenefitRate: 'update-client-benefit-rate-details',
      addPlansFormsFromLibrary: 'add-plans-forms-from-library',
      addPlansDocumentsFromLibrary: 'add-plans-documents-from-library',
      GetFormsList: 'get-forms-list',
      GetClientFormsList: 'get-client-forms-list',
      GetDocumentsList: 'get-documents-list',
      GetClientDocumentsList: 'get-client-documents-list',
      AddBenefitDeductionCode: 'add-benefit-deduction-code',
      UpdateBenefitDeductionCode: 'update-benefit-deduction-code',
      GetBenefitDeductionCode: 'get-benefit-deduction-code',
      AddClientPlansForm: 'add-client-plans-form',
      GetClientPlansForms: 'get-client-plans-forms',
      AddClientPlansFormsFromLibrary: 'add-client-plans-forms-from-library',
      DeleteClientPlansForm: 'delete-client-plans-form',
      AddClientPlansDocument: 'add-client-plans-document',
      GetClientPlansDocuments: 'get-client-plans-documents',
      AddClientPlansDocumentsFromLibrary: 'add-client-plans-documents-from-library',
      DeleteClientPlansDocument: 'delete-client-plans-document',
      DeleteDeductionCode: 'delete-deduction-code',
      DeleteClientAssociatedPlans: 'delete-client-associated-plans',
      GetClientBenefitFormById: 'get-client-benefits-plans-forms-by-id',
      GetClientEnrollmentPlanDocument: 'get-client-enrollment-plan-document',

      AddBenefitDeductionCodeType: 'add-benefit-deduction-code-type',
      UpdateBenefitDeductionCodeType: 'update-benefit-deduction-code-type',
      GetBenefitDeductionCodeType: 'get-benefit-deduction-code-type',
      DeleteDeductionCodeType: 'delete-deduction-code-type',
      SectionValue: 'patch-section-125',
      AddBenefitBillingCode: 'add-benefit-billing-code',
      UpdateBenefitBillingCode: 'update-benefit-billing-code',
      GetBenefitBillingCode: 'get-benefit-billing-code',
      DeleteBillingCode: 'delete-billing-code',
      CheckPlanEnrolled: 'check-plan-enrolled-against-employee',
      // enrollment
      EmployeePayStubPdf: 'employee-paystub-pdf',
      EmployeeAllPayStubPdf: 'employee-all-paystub-pdf',
      GetEmployeePayRate: 'get-employee-payrate',
      GetEmployeePlacements: 'get-employee-placements',
      AddNewPayRate: 'add-new-payrate',
      GetPayRateHistory: 'get-payrate-history',
      UpdateEmployeeEmail: 'update-emp-email',
      CancelEmployeeEmail: 'cancel-emp-onb',
      GetJobPlacements: 'get-job-placements',
      EmployeeRequestedPto: 'get-employee-requested-pto',
      GetMainClientEmployeeStatus: 'get-main-employee-status',
      AddJobPlacement: 'add-job-placement',
      UpdateJobPlacement: 'update-job-placement',
      UpdateCheckStubVoidCheck: 'update-check-stub-void-check',
      getEmployeesByMainClient: 'get-employee-by-clientid',
      getEmployeesBySubClient: 'get-employee-by-subclientid',
      UpdateEmployeeTerminationStatus: 'update-employee-termination-status',
      EmployeeExport: 'get-employees-export',
      AllEmployeeIds: 'get-all-employees-id',
      getEmploymentTypeByName: 'get-employment-type-by-name',
      getEmploymentTypeAnonymous: 'get-employment-type-anonymous',
      TaxBreakdown: 'tax-breakdown',
      UploadImportEmployee: 'upload-import-employee',
      GetPaginatedImportData: 'get-paginated-import-data',
      SaveImportEmployee: 'save-import-employee',
      GetAllEmployeeJobLogs: 'employee_job_log',
      SaveImportEmployeeSheet: 'save-import-employee_sheet',
      GetImportEmployeeSheet: 'get-import-employee_sheet',
      EmployeeWorkerComp: 'employee-workers-comp',
      EmployeeTaxBreakdownFromHistory: 'employee-tax-breakdown-from-history',
      Employeetaxhistorydetail: 'employee-tax-history-detail',
      GetEmployeeByGuid: 'get-employee-by-guid',
      BenchEmployee: 'bench-emp',
      DeployEmployee: 'deploy-emp',
      GetEmployeeMessageInfoByClient: 'get-employee-message-info-by-client',
      GetRecepientDetails: 'get-recepient-details',
      GetMainEmployeeStatus: 'get-main-employee-status',
      UpdateEmployeeTaxType: 'update-employee-tax-type',
      AddPtoForTermination: 'add-pto-for-termination',
      GetClientRateDetails: 'get-client-rate-details',
      ConfigureRates: 'configure-rates',
      GetBenefitRatesMain: 'get-benefit-rate-main-list',
      UpdateRateStatus: 'update-rate-status',
      DeleteRate: 'delete-rate',
      GetBenefitPlanCodeDetails: 'get-benefit-plan_code_details',
      GetBenefitPlansForBillingRule: 'search-client-benefit-plans-for-billing-rule',
      BenefitPlanTermination: 'benefit-plan-termination',
      CheckPlanEnrollment: 'check-plan-enrollment-against-employee',
};
